import '@uppy/core/css/style.min.css';
import '@uppy/dashboard/css/style.min.css';
import '@uppy/webcam/css/style.min.css';
import '@uppy/screen-capture/css/style.min.css';

import { useEffect } from 'react';

import type { Id } from '@e-socna/data-layer';

import { useUppyUploadInstance } from '../../hooks/useUppyUploadInstance';

import { FilesUploadDashboard } from './FilesUploadDashboard';

interface FilesUploadProps {
  readonly entityId: Id;
  readonly fileCategoryId: Id;
  readonly tusCategory: string;
  readonly entityLabel?: string;
  readonly fileCategoryLabel?: string;
  readonly onUploadSuccess?: () => void;
  readonly queryDocumentNamesToInvalidate: readonly string[];
}

export const FilesUpload = ({
  entityId,
  fileCategoryId,
  tusCategory,
  entityLabel,
  fileCategoryLabel,
  onUploadSuccess,
  queryDocumentNamesToInvalidate,
}: Readonly<FilesUploadProps>) => {
  const uppy = useUppyUploadInstance({
    entityId,
    fileCategoryId,
    tusCategory,
    label: entityLabel,
    fileCategoryLabel,
    queryDocumentNamesToInvalidate,
  });

  useEffect(() => {
    if (!uppy || !onUploadSuccess) {
      return undefined;
    }

    uppy.on('upload-success', onUploadSuccess);

    return () => {
      uppy.off('upload-success', onUploadSuccess);
    };
  }, [uppy, onUploadSuccess]);

  // uppy is briefly null while useUppyUploadInstance's effect resolves the instance (see its
  // comment). Splitting into an inner component keeps FilesUploadDashboard's hooks
  // unconditional once uppy is ready, instead of sprinkling `uppy?.` everywhere.
  if (!uppy) {
    return <div className="uppy-Container" />;
  }

  return <FilesUploadDashboard uppy={uppy} />;
};
